import { DisclosurePanel } from 'react-aria-components';
import styled from 'styled-components';

export const HeadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 50px;
  background: var(--grey-100);

  &:is([data-focus-visible-within] &) {
    box-shadow: var(--shadow-focus);
    border: 1px solid var(--brand-600);
  }

  & .react-aria-Heading {
    flex: 1;
    display: flex;
    height: 100%;

    & .react-aria-Button[slot=trigger] {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: var(--spacing-small);
      padding-inline: var(--spacing-large);
      background: inherit;
      border: 0;
      box-shadow: none;
      font-size: var(--font-size-text-sm);
      font-weight: var(--font-weight-regular);
      color: var(--brand-900);

      &[data-focused] {
        outline: 0;
      }

      & svg {
        width: 24px;
        rotate: none;
        transition: rotate 200ms;

        &:is([data-expanded] .react-aria-Button[slot=trigger] svg) {
          rotate: -180deg;
        }
      }
    }
  }
`;

export const Panel = styled(DisclosurePanel)`
  &:not([hidden="until-found"]) {
    padding: var(--spacing-large) var(--spacing-large) calc(var(--spacing-large) * 2);
    background: var(--white);
  }
`;

export const Preview = styled.span`
  padding-inline: var(--spacing-large);
  font-size: var(--font-size-text-md);
  font-weight: var(--font-weight-semibold);
`;
